//export const BASE_URL = "https://localhost:44355";

export const BASE_URL = "https://api-empleoslab.azurewebsites.net/";

localhost:44355
export const KEY_LOCALSTORE = "xds"

export const MES = [
  { value: "Enero", text: "Enero" },
  { value: "Febrero", text: "Febrero" },
  { value: "Marzo", text: "Marzo" },
  { value: "Abril", text: "Abril" },
  { value: "Mayo", text: "Mayo" },
  { value: "Junio", text: "Junio" },
  { value: "Julio", text: "Julio" },
  { value: "Agosto", text: "Agosto" },
  { value: "Septiembre", text: "Septiembre" },
  { value: "Octubre", text: "Octubre" },
  { value: "Noviembre", text: "Noviembre" },
  { value: "Diciembre", text: "Diciembre" },
];

export const NACIONALIDADES=  [
  "afegão",
  "andorrano",
  "angolano",
  "antiguano",
  "argelino",
  "argentino",
  "armênio",
  "australiano",
  "austríaco",
  "azeri",
  "bahamense",
  "bangladês",
  "barbadiano",
  "baremita",
  "bielorrusso",
  "belga",
  "belizenho",
  "beninense",
  "boliviano",
  "bósnio",
  "bechuano",
  "brasileiro",
  "bruneano",
  "búlgaro",
  "burquinense",
  "burundês",
  "butanense",
  "cabo-verdiano",
  "camaronense",
  "cambojano",
  "canadense",
  "centroafricano",
  "chadiano",
  "chinês",
  "chileno",
  "cookiano",
  "colombiano",
  "comoriano",
  "costa-riquenho",
  "croata",
  "Cubano",
  "cipriota",
  "tcheco",
  "congolense",
  "dinamarquês",
  "djibutiense",
  "dominiquense",
  "dominicano",
  "timorense",
  "equatoriano",
  "egípcio",
  "salvadorenho",
  "inglês",
  "guinéu-equatoriano",
  "eritreu",
  "estoniano",
  "fijiano",
  "finlandês",
  "francês",
  "gabonense",
  "gambiano",
  "geórgico",
  "alemão",
  "granadino",
  "grego",
  "guatemalteco",
  "guineano",
  "guineense",
  "guianense",
  "haitiano",
  "holandês",
  "hondurenho",
  "húngaro",
  "islandês",
  "indiano",
  "indonésio",
  "iraniano",
  "irlandês",
  "israelita",
  "italiano",
  "costa-marfinense",
  "jamaicano",
  "japonês",
  "jordão",
  "cazaque",
  "queniano",
  "quiribatiano",
  "quirguistanês",
  "kuwaitiano",
  "laosiano",
  "letoniano",
  "libanês",
  "lesotiano",
  "liberiano",
  "liechtensteinense",
  "lituano",
  "luxemburguês",
  "líbio",
  "macedônio",
  "madagascarense",
  "malaio",
  "malauiano",
  "maldivo",
  "maliano",
  "maltês",
  "mauriciano",
  "mauritano",
  "marshallino",
  "micronésio",
  "mexicano",
  "marroquino",
  "moldávio",
  "monegasco",
  "mongol",
  "montenegrino",
  "moçambicano",
  "birmanês",
  "namibiano",
  "nauruano",
  "nepalês",
  "neozelandês",
  "nicaraguense",
  "nigerino",
  "nigeriano",
  "niuano",
  "norte-coreano",
  "norueguês",
  "omanense",
  "palestino",
  "paquistanês",
  "palauense",
  "panamenho",
  "papuásio",
  "paraguaio",
  "peruano",
  "filipino",
  "polonês",
  "português",
  "catarense",
  "romeno",
  "russoruandês",
  "samoano",
  "santa-lucense",
  "são-cristovense",
  "são-marinense",
  "são-tomense",
  "são-vicentino",
  "escocês",
  "senegalense",
  "servio",
  "seichelense",
  "serra-leonês",
  "singapurense",
  "eslovaco",
  "salomônico",
  "somali",
  "sul-africano",
  "coreano",
  "sul-sudanense",
  "espanhol",
  "srilankês",
  "sudanense",
  "surinamês",
  "suazi",
  "sueco",
  "suíço",
  "sírio",
  "Tadiquistão",
  "tajique",
  "tanzaniano",
  "tailandês",
  "togolês",
  "tonganês",
  "trinitário",
  "tunisiano",
  "turcomeno",
  "turco",
  "tuvaluano",
  "ucraniano",
  "ugandês",
  "uruguaio",
  "árabe",
  "britânico",
  "americano",
  "uzbeque",
  "vanuatuano",
  "venezuelano",
  "vietnamita",
  "galês",
  "iemenita",
  "zambiano",
  "zimbabueano"
]

export const ESTADO_CIVIL = [
  { value: "Casado", text: "Casado" },
  { value: "Soltero", text: "Soltero" },
  { value: "Unión Libre", text: "Unión Libre" },
];

export const PARENTESCO = [
  { value: "Abuelos", text: "Abuelos" },
  { value: "Cónyugue", text: "Cónyugue" },
  { value: "Hermano/a", text: "Hermano/a" },
  { value: "Hijastro/a", text: "Hijastro" },
  { value: "Hijo(a)", text: "Hijo(a)" },
  { value: "Madre", text: "Madre" },
  { value: "Padre", text: "Padre" },
  { value: "Primo/a", text: "Primo/a" },
  { value: "Suegro/a", text: "Suegro/a" },
  { value: "Tio/a", text: "Tio/a" },
];

export const SANGRE = [
  { value: "A+", text: "A+" },
  { value: "A-", text: "A-" },
  { value: "AB+", text: "AB+" },
  { value: "AB-", text: "AB-" },
  { value: "B+", text: "B+" },
  { value: "B-", text: "B-" },
  { value: "O+", text: "O+" },
  { value: "O-", text: "O-" },
];

export const NIVEL_IDIOMA = [
  { value: "Básico", text: "Básico" },
  { value: "Avanzado", text: "Avanzado" },
  { value: "Instermedio", text: "Instermedio" },
];

export const NIVEL_EDUCATIVO = [
  { value: "Educacion Basica", text: "Educacion Basica" },
  { value: "Bachiller", text: "Bachiller" },
  { value: "Curso Tecnico", text: "Curso Tecnico" },
  { value: "Certificacion", text: "Certificacion" },
  { value: "Diplomado", text: "Diplomado" },
  { value: "Doctorado", text: "Doctorado" },
  { value: "Grado Academico", text: "Grado Academico" },
  { value: "Especialidad", text: "Especialidad" },
  { value: "Maestria", text: "Maestria" },
  { value: "Post-grado", text: "Post-grado" },
  { value: "Seminario", text: "Seminario" },
  { value: "Taller", text: "Taller" },
];

export const ESTATUS = {
  "N" : { color: "dark" },
  "E" : {   color: "warning" },
  "NoDisponible" : {  color: "danger", text:"No disponible" },
  "Disponible" : {color: "success", text: "Disponible" },
  "Inactivo" : { color: "danger" },
  "Activo" : {  color: "success" }
};

export const ESTATUS_SOLICITUD=[
  {text:"Todas", value:""},
  {text:"Enviado", value:"Enviado"},
  {text:"Revisado", value:"Revisado"}
]

export const COLOR_PDF  = {

  colorGreen: [3, 131, 61], 
  colorBlack:  [0, 0, 0],
  colorGray:  [117, 117, 117],
}